export default __webpack_public_path__ + "static/media/history.55e5d81a.png";